<template>
  <div class="post__podcast__wrapper">
    <div class="post__podcast">
      <TestvTabs
        :class="[
          'comp__TestvTabs',
          `comp__TestvTabs--${active}`
        ]"
        v-model="active"
        :options="tabs">
        <div class="testv__audio__player__header" slot="audio">
          <div class="testv__audio__cover__wrapper">
            <img
              class="testv__audio__cover"
              :src="$imageUrl(audio.cover) || 'https://cdn-static.sspai.com/page/testv/assets/placeholder.jpeg'"
              alt="封面"
            />
          </div>
          <div class="testv__audio__issue">{{ audio.issue }}</div>
          <div class="testv__audio__name">{{ audio.name }}</div>
        </div>

        <TestvShownotes
          slot="shownotes"
          :shownotes="post.podcast_configs"
        />

        <div slot="comments" class="post__comments">
          <div class="post__comments__head">
            <div class="comment__count"><IconComment class="icon__comment"/><span>{{ total }}</span></div>
            <div class="title">{{ post.title }}</div>
          </div>

          <PostComment
            class="comp__PostComment"
            ref="comments"
            :articleInfo="post"
            articleType="paid"
            :comments="comments"
          />
          <SSLoading
            class="comp__SsLoading"
            :loading="loading"
            :loadEnd="loadEnd"
            :noDataAvailable="!comments.length"
            noDataAvailableText="暂无数据"
            loadEndText="没有更多数据了"
          />
        </div>
      </TestvTabs>

      <TestvAudioPlayer
        v-show="active === 'audio' || active === 'shownotes'"
        class="comp__TestvAudioPlayer"
        ref="player"
        :audio="audio"
        :node="post.podcast_configs"
        @whenPlay="whenPlay"
        @whenPlaying="whenPlaying"
      />
    </div>
  </div>
</template>

<script>
import ScrollMagic from 'scrollmagic'
import postMixin from '../post-mixin.js'
import TestvAudioPlayer from '@/components/TestvAudioPlayer/index.vue'
import TestvTabs from '@/components/TestvTabs/index.vue'
import TestvShownotes from '@/components/TestvShownotes/index.vue'
import PostComment from '../_components/PostComment/index.vue'

export default {
  name: 'PostPodcast',

  mixins: [postMixin],

  components: {
    TestvAudioPlayer,
    TestvTabs,
    TestvShownotes,
    PostComment
  },

  data () {
    return {
      active: 'audio',
      scene: null,
      controller: null
    }
  },

  computed: {
    tabs () {
      if (!this.post || !this.post.podcast_configs.length) {
        return [
          { name: 'audio', icon: 'IconPlay' },
          { name: 'comments', icon: 'IconComment' }
        ]
      }
      return [
        { name: 'audio', icon: 'IconPlay' },
        { name: 'shownotes', icon: 'IconPost' },
        { name: 'comments', icon: 'IconComment' }
      ]
    },
    canRead () {
      if (this.post) {
        const { is_free, is_pay, probation } = this.post
        return is_free || is_pay || probation
      }
      return true
    },
    audio () {
      if (this.post && this.canRead) {
        return {
          url: this.post.podcast_url,
          // url: 'https://cdnfile.sspai.com/audio/podcast/01_city_sound.mp3',
          cover: this.post.banner,
          name: this.post.title,
          issue: this.post.issue
        }
      }
      return { url: '' }
    }
  },

  methods: {
    whenPlay (playing) {
      const podcastCard = document.querySelector('.podcast-card')
      if (!podcastCard) return
      if (playing) {
        podcastCard.classList.remove('no-animation')
      } else {
        podcastCard.classList.add('no-animation')
      }
    },
    whenPlaying () {
      // console.log(e)
      if (this.articleInfo && this.articleInfo.podcast_configs && this.articleInfo.podcast_configs.length) {
        const nodes = [].concat(this.articleInfo.podcast_configs.map(el => el.time_slot), this.$refs.player.player.audio.duration)
        const ct = this.$refs.player.player.audio.currentTime
        for (let i = 0; i < nodes.length; i++) {
          if (ct >= nodes[i] && ct < nodes[i + 1] && !this.swiperTimer) {
            this.swiper.slideTo(i)
            break
          }
        }
      }
    },
    resize () {
      this.scene = new ScrollMagic.Scene({
        triggerElement: '.el-tabs__header',
        triggerHook: 'onLeave',
        offset: 0 - (document.querySelector('#app-head').offsetHeight),
      })
      .setPin('.el-tabs__header')
      .addTo(this.controller)
    }
  },

  mounted () {
    this.controller = new ScrollMagic.Controller()
    setTimeout(() => {
      this.resize()
    }, 1000)
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/styles/variable.styl'
.post__podcast {
  max-width: 856px;
  min-height: calc(var(--vh, 1vh) * 100 - var(--h-header) - env(safe-area-inset-bottom, 0px));
  box-sizing: border-box;
  margin: auto;
  display: flex;
  flex-direction: column;
}

.comp__TestvTabs {
  flex: 1;
  display: flex;
  flex-direction: column;
  >>> .el-tabs__header {
    margin-bottom: 0px;
    z-index: 9;
    padding: 16px;
    background: var(--dark-bwb-0);
    @media (min-width: $screen-md) {
      padding: 32px;
    }
  }
  >>> .el-tabs__content {
    margin: auto 0;
    padding: 24px 20px;
    @media (min-width: $screen-md) {
      padding: 32px;
    }
  }
  >>> .el-tab-pane {
    height: 100%;
  }
}

.comp__TestvTabs--comments {
  >>> .el-tabs__header {
    border-bottom: 1px solid var(--dark-bwb-3);
  }
  >>> .el-tabs__content {
    padding: 0px;
  }
}

.comp__TestvAudioPlayer {
  max-width: 856px;
  height: 100%;
  margin-top: auto;
  display: flex;
  flex-direction: column;
  padding: 0 20px 24px;
  @media (min-width: $screen-md) {
    padding: 0 32px 64px;
  }
}

.testv__audio__cover__wrapper {
  width: 256px;
  height: 256px;
  border-radius: 4px;
  margin: auto;
  margin-bottom: 16px;
  .testv__audio__cover {
    width: 100%;
    height: 100%;
    border-radius: inherit;
    object-fit: cover;
    object-position: center;
  }
  @media (min-width: $screen-md) {
    width: 370px;
    height: 370px;
  }
}

.testv__audio__issue {
  color: var(--dark-bwb-5);
  font-size: 13px;
  font-weight: 500;
  font-family: ui-monospace, 'SF Mono', monospace;
  text-align: center;
  @media (min-width: $screen-md) {
    font-size: 15px;
  }
}

.testv__audio__name {
  color: var(--dark-bwb-8);
  font-size: 15px;
  font-weight: 500;
  margin-top: 4px;
  text-align: center;
  @media (min-width: $screen-md) {
    font-size: 20px;
  }
}

.post__comments__head {
  display: none;
  @media (min-width: $screen-md) {
    display: flex;
  }
  justify-content: space-between;
  align-items: center;
  max-width: 644px;
  padding:  0 20px;
  margin: 30px auto 16px;
  .comment__count {
    font-size: 32px;
    font-weight: 500;
    font-family: "DottedSongtiSquare";
    display: flex;
    align-items: center;
    column-gap: 4px;
    .icon__comment {
      width: 40px;
      height: 40px;
    }
  }
  .title {
    font-size: 13px;
    color: var(--dark-bwb-3);
    max-width: 185px;
  }
}

.post__comments {
  margin-top: 24px;
}

.comp__SsLoading {
  margin-bottom: 10px;
}
</style>
